<template>
  <div class="content-container">
    <template v-if="step === 0">
        <ContentBox title="选择广告位" >
          <el-form
            :model="form"
            label-width="125px"
            label-position="left"
            hide-required-asterisk
            class="demo-ruleForm"
            >
            <el-col>
              <el-form-item label="广告位">
                <el-select v-model="form.spaceId" clearable filterable @change="handleChangSpace">
                  <el-option
                    v-for="item in spaceOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    placeholder="请选择"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="分辨率" v-show="form.spaceId">
                {{form.resolution}}
              </el-form-item>
            </el-col>
          </el-form>
        </ContentBox>
        <ContentBox>
          <el-button plain @click="handleGoBack">取消</el-button>
          <el-button type="primary" :disabled="disabledNextBtn" @click="goNext">下一步</el-button>
        </ContentBox>
    </template>
    <template v-if="step === 1">
          <OnlineClip
            :spaceInfo="spaceInfo"
            v-if="isShowOnlineClip"
            :is-show-online-clip="isShowOnlineClip"
            :is-changed-cover="isChangedCover"
            :edit-id="editId"
            @add-material="handleMaterialAdd"
            @online-clip-close="handleOnlineClipClose"
            @save-close-refresh="handelTabRefresh"
            @clear-edit-id="handleEditIdClear"
            @go-back="$emit('go-back')"
          ></OnlineClip>
    </template>
  </div>
</template>
<script>
import OnlineClip from '@/components/onlineClip/OnlineClip'
import materialStore from './store'
export default {
  components: {
    OnlineClip
  },
  provide() {
    return {
      handleMaterialAdd: this.handleMaterialAdd,
      getSelectedMaterial: this.getSelectedMaterial
    }
  },
  data() {
    return {
      step: 0,
      isShowOnlineClip: true,
      isChangedCover: false,
      editId: undefined,
      spaceOptions: [],
      sizeOptions: [],
      form: {
        spaceId: undefined,
        resolution: undefined
      },
      spaceInfo: {
      }
    }
  },
  computed: {
    disabledNextBtn() {
      if (this.form.spaceId) {
        return false
      } else {
        return true
      }
    }
  },
  methods: {
    handleMaterialAdd(material) {
      let target = this.getMaterial(material)
      if (target) {
        this.$message('视频已选择')
        return false
      }
      if (!target) {
        const target = Object.assign({}, material)
        target.startTime = target.startFrame
        target.endTime = target.endFrame
        materialStore.addedMaterial.push(target)
        // this.isChangedCover = false
      }
    },
    handleOnlineClipClose() {
      this.isShowOnlineClip = false
    },
    handelTabRefresh(way) {
      this.isShowOnlineClip = false
      if (way && this.selectedPart === 'clipQuene') {
        this.$refs.clipQuene.fetchData()
      }
      if (!way && this.selectedPart === 'myPreservedWorks') {
        this.$refs.myPreservedWorks.fetchData()
      }
      this.handleEditIdClear()
    },
    handleEditIdClear() {
      this.editId = null
    },
    getMaterial(material) {
      const target = materialStore.addedMaterial.find(item => {
        const id = item.coocaaMId === material.coocaaMId
        const start = item.startFrame === material.startFrame
        const end = item.endFrame === material.endFrame
        return id && start && end
      })
      return target
    },
    getSelectedMaterial(material, isEdit, list) {
      let realList = []
      if (isEdit) {
        realList = list
      } else {
        realList = materialStore.addedMaterial
      }
      let target = realList.find(item => {
        const id = item.coocaaMId === material.coocaaMId
        const start = item.startFrame === material.startFrame
        const end = item.endFrame === material.endFrame
        return id && start && end
      })
      return target
    },
    goNext() {
      this.step = 1
    },
    getSpaceList() {
      this.$service.getVideoSpaceList().then(data => {
        this.spaceOptions = (data || []).map(item => {
          return {
            label: item.spaceName,
            value: item.spaceId,
            maxResolution: item.maxResolution,
            minResolution: item.minResolution
          }
        })
      })
    },
    handleChangSpace(val) {
      const selected = this.spaceOptions.filter(item => item.value === val)
      if (selected[0].maxResolution && selected[0].minResolution) {
        this.form.resolution = selected[0].minResolution + ' - ' + selected[0].maxResolution
      } else {
        this.form.resolution = selected[0].maxResolution
      }
      // this.spaceInfo = Object.assign({ spaceName: selected[0].spaceName }, this.form)
      this.spaceInfo = { ...this.form, ...{ spaceName: selected[0].label } }
    },
    handleGoBack() {
      if (this.form.spaceId) {
        this.$confirm('页面内容未保存，确定要离开吗？', '提示', {
          confirmButtonText: '离开页面',
          cancelButtonText: '留在页面',
          center: true,
          type: 'warning'
        }).then(() => {
          this.$emit('go-back')
        })
      } else {
        this.$emit('go-back')
      }
    }
  },
  created() {
    this.getSpaceList()
  }

}
</script>
<style lang="stylus" scoped>
.content-container
  margin 16px
.demo-ruleForm
  max-width 800px
  >>>.el-select
    width 100%
</style>
